//顶部菜单
export const topMenu = [
    {
        name: '关于',
        anchor: 'About'
    },
    {
        name: '愿景',
        anchor: 'Vision'
    },
    {
        name: '投资理念',
        anchor: 'Approach'
    },
    {
        name: '投资重点',
        anchor: 'FocusAreas'
    },
    {
        name: '价值观',
        anchor: 'Values'
    },
    {
        name: '服务',
        anchor: 'Services'
    },
    {
        name: '联系',
        anchor: 'Contact'
    }
]

//首页主页
export const homePage = {
    title: '资本之外，成就未来',
    content: '赋能 Web3 创新的未来',
    website: 'www.bitgo.capital'
}

//关于我们
export const about = {
    title: '关于我们',
    theFirstSentence: '成立于 2023 年，Bitgo Capital 是一家新一代全球投资机构，致力于发掘并支持具备潜力的 Web3 初创企业。',
    secondSentence: '我们不仅提供资金支持，更通过战略咨询、产业资源与生态建设，助力有远见的团队实现跨越式成长。'
}

//愿景与使命
export const visionAndMission = {
    title: '愿景与使命',
    visionTitle: '愿景',
    visionContent: '成为 Web3 创新的催化剂，塑造去中心化的未来。',
    missionTitle: '使命',
    missionContent: ' 赋能创业者，将创意转化为有影响力的现实。',
}

//投资理念
export const approach = {
    title: '投资理念',
    item: [
        {
            title: '资本支持',
            content: '早期与成长期融资'
        },
        {
            title: '战略咨询',
            content: '商业模式与代币经济学指南'
        },
        {
            title: '生态建设',
            content: '连接项目、合作伙伴与社区'
        },
        {
            title: '资源整合',
            content: '通过全球网络释放机遇'
        }
    ]
}

// 投资重点
export const focusAreas = {
    title: '投资重点',
    content: '我们的投资重点涵盖 Web3 前沿赛道',
    item: [
        "区块链基础设施",
        "游戏金融与元宇宙",
        "去中心化金融与数字资产",
        "人工智能与 Web3 融合",
        " 跨境支付与金融科技"
    ]
}

// 核心价值观
export const values = {
    title: '核心价值观',
    item: [
        {
            title: '诚信',
            content: '在每一份合作中坚持透明与信任'
        },
        {
            title: '创新',
            content: '拥抱大胆的理念与颠覆性创新'
        },
        {
            title: '协作',
            content: '携手共建，共享成长'
        },
        {
            title: '可持续',
            content: '支持长期的积极影响'
        }
    ]
}

//我们的服务
export const service = {
    title: '我们的服务',
    content: '除了投资，我们还提供',
    item: [
        "市场进入策略",
        "合规与风险咨询",
        "合作伙伴拓展",
        "人才与领导力支持"
    ]
}

// 投资哲学
export const investmentPhilosophy = {
    title: '投资哲学',
    content: '我们相信 长期价值的创造，支持那些超越市场热潮、真正构建未来的创业者。'
}

// 全球布局
export const globalPresence = {
    title: '全球布局',
    content: 'Bitgo Capital 在全球主要创新中心布局并建立生态合作关系',
    item: [
        "香港",
        "新加坡",
        "欧洲",
        "美国"
    ]
}

// 我们的优势
export const distinctiveEdge = {
    title: ' 我们的优势',
    content: '为什么选择 Bitgo Capital？',
    item: [
        {
            title: '全球网络',
            content: '从亚洲到欧洲，再到美国'
        },
        {
            title: ' 创业者导向',
            content: '我们投资于人才，而不仅仅是产品'
        },
        {
            title: '生态优先',
            content: '构建能倍增价值的连接'
        },
        {
            title: '不止资金',
            content: '战略、资源与可持续增长'
        }
    ]
}

// 知识与洞察
export const knowledgeInsights = {
    title: '知识与洞察',
    content: '我们不仅是投资者，更是 行业思考者。'
}

// 我们的承诺
export const commitment = {
    title: '我们的承诺',
    item: [
        "以透明与责任制运营",
        "支持符合全球监管标准的项目",
        "推动 Web3 生态的长期积极影响"
    ]
}

// 联系我们
export const contact = {
    title: '联系我们',
    content: '我们欢迎有远见的创业者与战略伙伴与我们联系。',
    email: '邮箱',
    website: '网址'
}

//资讯条幅
export const informationBannerItems = [
    {
        title: 'OneChain 正式宣布完成 A 轮战略融资，募集资金 6700 万美元。',
        media: 'Odaily',
        date: '2026.02.18',
        link: 'https://m.odaily.news/zh-CN/newsflash/469016'
    },
    {
        title: 'OneChain 正式宣布完成 A 轮战略融资，募集资金 6700 万美元。',
        media: 'Linkedin',
        date: '2026.02.18',
        link: 'https://www.linkedin.com/posts/bitgo-capital_congratulations-onechain-announces-the-completion-activity-7429815086757883904-fgkk?utm_source=share&utm_medium=member_ios&rcm=ACoAAE6dDE4BWBEINU915z_HsFlfd_mtS0YBark'
    }
]
